import React from 'react';
import styled from 'styled-components';
import { toRem } from 'design';
import { Avatar, IAvatarProps } from '../Avatar';

const StyledAvatar = styled(Avatar).attrs({ size: 'large' })`
  margin-bottom: ${toRem(22)};
`;

const ModalAvatar: React.FC<IAvatarProps> = ({ username, image, hasPaymentMethod, isLoading, className }) => <StyledAvatar username={username} image={image} hasPaymentMethod={hasPaymentMethod} isLoading={isLoading} className={className} />;

export default ModalAvatar;
